import React from 'react';
import { Card, Stack, Text, Group, Badge, Divider } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';
import type { CoursePlanJobFamilyGroup } from '../../../../types/lcms/coursePlan';

interface PlanJobFamilyGroupsSectionProps {
  jobFamilyGroups: CoursePlanJobFamilyGroup[];
}

const PlanJobFamilyGroupsSection: React.FC<PlanJobFamilyGroupsSectionProps> = ({
  jobFamilyGroups
}) => {
  if (!jobFamilyGroups || jobFamilyGroups.length === 0) {
    return (
      <Card>
        <Group gap={12} mb={16}>
          <IconUsers size={20} />
          <Text fw={600} size='lg'>
            Job Family Groups
          </Text>
        </Group>
        <Text c='dimmed' size='sm' style={{ fontStyle: 'italic' }}>
          No job family groups assigned to this course plan
        </Text>
      </Card>
    );
  }

  return (
    <Card>
      <Group gap={12} mb={16}>
        <IconUsers size={20} />
        <Text fw={600} size='lg'>
          Job Family Groups ({jobFamilyGroups.length})
        </Text>
      </Group>

      <Stack gap={12}>
        {jobFamilyGroups.map((item, index) => (
          <React.Fragment key={item.trLCMSPlanningJobFamilyGroupsID}>
            <Group justify='space-between' align='flex-start'>
              <Stack gap={4} flex={1}>
                <Text fw={500} size='sm'>
                  {item.jobFamilyGroupName}
                </Text>
                <Group gap={8}>
                  <Badge variant='light' size='xs' color='green'>
                    ID: {item.jobFamilyGroupID}
                  </Badge>
                </Group>
              </Stack>
            </Group>
            {index < jobFamilyGroups.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </Stack>
    </Card>
  );
};

export default PlanJobFamilyGroupsSection;
